module.exports = __webpack_public_path__ + "img/banner-rule.7e906728.jpg";